import { axiosInstance } from '.'
import {
  COMING_SOON_ADMIN_LIST,
  COMING_SOON_BY_ID,
  COMING_SOON_CREATE,
  COMING_SOON_DELETE,
  COMING_SOON_UPDATE,
  UPLOAD_FILE,
} from './endpoints'

export type ComingSoonAdminRow = {
  id: number
  cover_image: string
  title: string
  description: string
  sort_order: number
  is_published: boolean
  created_at?: string
  updated_at?: string
}

export type ComingSoonFormData = {
  cover_image: string
  title: string
  description: string
  sort_order: number
  is_published: boolean
}

export const comingSoonAdminServices = {
  listAll: async () => {
    const { data } = await axiosInstance.get<{ items: ComingSoonAdminRow[] }>(
      COMING_SOON_ADMIN_LIST,
    )
    return data?.items ?? []
  },

  getById: async (id: string) => {
    const { data } = await axiosInstance.get<ComingSoonAdminRow>(COMING_SOON_BY_ID(id))
    return data
  },

  create: async (payload: ComingSoonFormData) => {
    return axiosInstance.post(COMING_SOON_CREATE, payload)
  },

  update: async (id: string, payload: Partial<ComingSoonFormData>) => {
    return axiosInstance.patch(COMING_SOON_UPDATE(id), payload)
  },

  remove: async (id: string) => {
    return axiosInstance.delete(COMING_SOON_DELETE(id))
  },

  uploadFile: async (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return axiosInstance.post(UPLOAD_FILE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
